module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }